// Common quiz status for practice and final quiz
export const COMMON_QUIZ_STATUS = {
    NOT_STARTED: 'NotStarted', // user has not started the quiz
    STARTED: 'Started', // user started the quiz, but none of the answers were submitted yet
    IN_PROGRESS: 'InProgress', // user started the quiz and at least one answer was submitted
    FAILED: 'Failed',
    PASSED: 'Passed',
};

export const FINAL_QUIZ_STATUS = {
    NO_ATTEMPTS_LEFT: 'NoAttemptsLeft',
};

export const ANSWER_STATUS = {
    NOT_ANSWERED: 'NotAnswered',
    CORRECT: 'Correct',
    PARTIALLY_CORRECT: 'PartiallyCorrect',
    WRONG: 'Wrong',
};

export const QUIZ_NOTIFICATION = {
    READY: 'Ready',
    NO_ATTEMPTS_LEFT: 'NoAttemptsLeft',
    PATHWAY_NOT_COMPLETED: 'PathwayNotCompleted',
    FAILED_WITH_CURRENT_SCORE: 'FailedWithCurrentScore',
};
